<template>
  <router-view />
</template>

<script>
export default {
  name: 'LessonsIndex'
}
</script>
